module.exports = __webpack_public_path__ + "assets/img/seayak-junior-pro.b8ba239d.png";